const styles = theme => ({
  base: {
    // backgroundColor: '#FFFFFF',
    height: '100%'
  },
  main:{
    backgroundColor:'#fbfaff',
    minHeight: 'calc(100vh - 250px)',

  }
  
})

export default styles
